import { loadStripe } from '@stripe/stripe-js';

// Replace with your actual Stripe publishable key
// For testing, use your test key (pk_test_...)
// For production, use your live key (pk_live_...)
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_your_stripe_publishable_key_here';

// Initialize Stripe
export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

// Package pricing configuration
export const PACKAGE_PRICES = {
  call_with_concierge: {
    price: 29900, // $299.00 in cents
    currency: 'usd',
    displayPrice: '$299'
  },
  // Add more packages if needed
  // basic_consultation: {
  //   price: 9900, // $99.00 in cents
  //   currency: 'usd',
  //   displayPrice: '$99'
  // }
};

// Get package details by package ID
export const getPackageDetails = (packageId) => {
  return PACKAGE_PRICES[packageId] || PACKAGE_PRICES.call_with_concierge;
};

// Stripe appearance customization
export const stripeAppearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: '#0066cc',
    colorBackground: '#ffffff',
    colorText: '#30313d',
    colorDanger: '#df1b41',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    spacingUnit: '2px',
    borderRadius: '6px',
  },
  rules: {
    '.Input': {
      fontSize: '16px',
      padding: '12px',
      border: '1px solid #e0e0e0',
    },
    '.Input:focus': {
      border: '2px solid #0066cc',
      boxShadow: '0 0 0 1px #0066cc',
    },
    '.Label': {
      fontSize: '14px',
      fontWeight: '500',
      color: '#30313d',
      marginBottom: '6px',
    }
  }
};
